import { infoFetchGetPlanesEstudioI, makePlanEstudio } from "dtos/planEstudio";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const postPlanEstudio = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetPlanesEstudioI>({
    method: "POST",
    uri: ENDPOINTS.PLANES_ESTUDIO,
    images,
    params: servicesUtils.removeNullNonEmptyParamsInFilters(params),
  });

  // return makePlanEstudio(response)
};

export const putPlanEstudio = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetPlanesEstudioI>({
    method: "PUT",
    uri: ENDPOINTS.PLANES_ESTUDIO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  // return makePlanEstudio(response)
};

export const getPlanesEstudio = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetPlanesEstudioI>
  >({
    method: "GET",
    uri: ENDPOINTS.PLANES_ESTUDIO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makePlanEstudio(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getPlanEstudioById = async (id: any, params?: any) => {
  const response = await sendRequest<infoFetchGetPlanesEstudioI | undefined>({
    method: "GET",
    uri: ENDPOINTS.PLANES_ESTUDIO + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makePlanEstudio(response) : undefined;
};

export const getPlanesEstudioCount = async (params: any) => {
  const response = await sendRequest<number>({
    method: "GET",
    uri: ENDPOINTS.PLANES_ESTUDIO_COUNT,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response;
};

export const getPlanesEstudioCountValidados = async () => {
  const response = await sendRequest<number>({
    method: "GET",
    uri: ENDPOINTS.PLANES_ESTUDIO_COUNT_VALIDADOS,
  });
  return response;
};

export const getPlanesEstudioValidezPorVencer = async () => {
  const response = await sendRequest<number>({
    method: "GET",
    uri: ENDPOINTS.VALIDACION_NACIONAL_CANTIDAD_PLANES_POR_VENCER,
  });
  return response;
};

export const deletePlanEstudio = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.PLANES_ESTUDIO + "/" + id,
  });
  return response;
};
